import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React, { useContext } from 'react';
import DSButton from '@elliemae/ds-basic/Button';
import { ShuttleWrapper, ShuttleHeader, ShuttleHeaderBreadcrumb, ShuttleList, Overflow, LoadingList, ShuttleFooter, ShuttleFooterActions, ShuttleFooterCounter, EmptyMessage } from '../classedComponents.js';
import { getActiveIdFromHierarchy } from '../helper.js';
import AnimationContext from '../AnimationState.js';
import VirtualizedList from './VirtualizedList.js';
import ShuttleTargetListItem from './ShuttleListItem/ShuttleTargetListItem.js';
import VirtualizedSortableList from './VirtualizedSortableList.js';
import LoadingIndicator from './LoadingIndicator.js';
import '@elliemae/ds-classnames';
import './ShuttleBreadcrumb.js';
import 'react-spring/web.cjs';
import '@elliemae/ds-basic/Breadcrumb';
import '../animation/animationConfig.js';
import './OverflowList.js';
import '@babel/runtime/helpers/esm/defineProperty';
import '@elliemae/ds-utilities/utils';
import 'treetabular';
import '@babel/runtime/helpers/esm/slicedToArray';
import 'constate';
import 'react-window';
import 'react-window-infinite-loader';
import 'react-virtualized-auto-sizer';
import './VirtualizedItem.js';
import './ShuttleListItem/ActionButtons.js';
import '@elliemae/ds-icons/CloseCircle';
import '@elliemae/ds-icons/ArrowShortRight';
import '@elliemae/ds-icons/ArrowShortReturn';
import './ShuttleListItem/ShuttleListItem.js';
import '@elliemae/ds-basic/TruncatedTooltipText';
import 'react-sortable-hoc';
import '@elliemae/ds-icons/GripperVertical';
import '@elliemae/ds-basic/CircularProgressIndicator';
import 'styled-components';

var noop = function noop() {};

function ShuttleTarget(_ref) {
  var _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      _ref$hierarchy = _ref.hierarchy,
      hierarchy = _ref$hierarchy === void 0 ? [] : _ref$hierarchy,
      _ref$onNavigateTo = _ref.onNavigateTo,
      onNavigateTo = _ref$onNavigateTo === void 0 ? noop : _ref$onNavigateTo,
      _ref$onMoveItem = _ref.onMoveItem,
      onMoveItem = _ref$onMoveItem === void 0 ? noop : _ref$onMoveItem,
      _ref$onClearMovedItem = _ref.onClearMovedItems,
      onClearMovedItems = _ref$onClearMovedItem === void 0 ? noop : _ref$onClearMovedItem,
      _ref$emptyMessage = _ref.emptyMessage,
      emptyMessage = _ref$emptyMessage === void 0 ? 'No items selected' : _ref$emptyMessage,
      _ref$composeTargetIte = _ref.composeTargetItemProps,
      composeTargetItemProps = _ref$composeTargetIte === void 0 ? function () {
    return {};
  } : _ref$composeTargetIte,
      _ref$targetSortable = _ref.targetSortable,
      targetSortable = _ref$targetSortable === void 0 ? false : _ref$targetSortable,
      _ref$onSortEnd = _ref.onSortEnd,
      onSortEnd = _ref$onSortEnd === void 0 ? noop : _ref$onSortEnd,
      _ref$targetClearItems = _ref.targetClearItemsText,
      targetClearItemsText = _ref$targetClearItems === void 0 ? 'CLEAR ALL' : _ref$targetClearItems,
      _ref$renderTargetCoun = _ref.renderTargetCounter,
      renderTargetCounter = _ref$renderTargetCoun === void 0 ? function (amount) {
    return "".concat(amount, " items");
  } : _ref$renderTargetCoun,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading;

  var _useContext = useContext(AnimationContext.Context),
      _useContext$state$isM = _useContext.state.isMoving,
      isMoving = _useContext$state$isM === void 0 ? false : _useContext$state$isM;

  var isEmpty = !items.length;
  var emptyContent = loading ? /*#__PURE__*/React.createElement(LoadingIndicator, null) : /*#__PURE__*/React.createElement(EmptyMessage, null, emptyMessage);
  var ComponentList = targetSortable ? VirtualizedSortableList : VirtualizedList;

  var handleSortEnd = function handleSortEnd(_ref2) {
    var oldIndex = _ref2.oldIndex,
        newIndex = _ref2.newIndex;
    onSortEnd({
      sourceItem: items[oldIndex],
      targetItem: items[newIndex]
    });
  };

  return /*#__PURE__*/React.createElement(ShuttleWrapper, null, /*#__PURE__*/React.createElement(ShuttleHeader, null, /*#__PURE__*/React.createElement(ShuttleHeaderBreadcrumb, {
    hierarchy: hierarchy,
    onNavigateTo: onNavigateTo
  })), /*#__PURE__*/React.createElement(ShuttleList, {
    classProps: {
      showPulse: isMoving
    }
  }, !loading && !isEmpty ? /*#__PURE__*/React.createElement(Overflow, {
    activeHierarchy: getActiveIdFromHierarchy(hierarchy).id,
    classProps: {
      empty: !items.length
    }
  }, /*#__PURE__*/React.createElement(ComponentList, {
    itemRenderer: function itemRenderer(_ref3) {
      var item = _ref3.item,
          rest = _objectWithoutProperties(_ref3, ["item"]);

      return /*#__PURE__*/React.createElement(ShuttleTargetListItem, _extends({
        "data-testid": "target-list-item"
      }, rest, composeTargetItemProps(item, rest), {
        isRoot: !getActiveIdFromHierarchy(hierarchy).id,
        item: item,
        onMoveToSource: onMoveItem,
        onNavigateOnTargetTo: onNavigateTo,
        showSortHandler: targetSortable
      }));
    },
    items: items,
    onSortEnd: handleSortEnd,
    target: true
  })) : /*#__PURE__*/React.createElement(LoadingList, null, emptyContent)), /*#__PURE__*/React.createElement(ShuttleFooter, null, /*#__PURE__*/React.createElement(ShuttleFooterActions, null, !!items.length && /*#__PURE__*/React.createElement(DSButton, {
    containerProps: {
      'data-testid': 'shuttle-clear-all-target'
    },
    buttonType: "link",
    labelText: targetClearItemsText,
    onClick: onClearMovedItems
  })), /*#__PURE__*/React.createElement(ShuttleFooterCounter, null, renderTargetCounter(items.length))));
}

export default ShuttleTarget;
//# sourceMappingURL=ShuttleTarget.js.map
